
<template>
  <div>
    <v-btn @click="dialog = true" small class="primary">
      <v-icon left small>mdi-history</v-icon>
      <span>Histórico de bloqueios</span>
    </v-btn>
    <v-dialog width="90%" v-model="dialog" persistent>
      <dialog-loading v-if="loading"></dialog-loading>
      <v-card v-if="!loading">
        <v-card-title>
          <span>Histórico de bloqueios</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text style="overflow-y: auto; max-height:75vh">
          <v-data-table :items="block_history" :headers="headers">
            <template v-slot:item.kind="{item}">
              <v-chip small :class="block_map[item.kind].color">
                {{ block_map[item.kind].text }}
              </v-chip>
            </template>
            <template v-slot:item.created_at="{item}">
              {{ $moment(item.created_at).format('DD/MM/YYYY HH:mm') }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" small @click="dialog = false">Voltar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'ClientBlockHistory',
  props: {
    client_id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      block_map:{
        "block": {text:"Bloqueio", color:"error"},
        "unblock": {text:"Desbloqueio", color:"primary"},
      },
      block_history: [],
      headers:[
        { text: 'Ação', value: 'kind', align: 'center' },
        { text: 'Alterado por', value: 'changed_by', align: 'center' },
        { text: 'Comentário', value: 'comment', align: 'center' },
        { text: 'Data', value: 'created_at', align: 'center' },
      ],
    }
  },
  methods: {
    getData() {
      this.getBlockHistory()
    },
    getParams(){
      return {
        client_id: this.client_id ? this.client_id : this.$route.params.id
      }
    },
    getBlockHistory() {
      this.loading = true
      let params = this.getParams()
      Api.ClientBlockLog.index(params).then((res)=> {
        this.block_history = [...res.data]
      }).finally(()=>{
        this.loading = false
      })
    },
  },
  mounted(){
    this.getData()
  }
}
</script>